import React from 'react';
import { Link } from 'react-router-dom';
import { ApiOutlined, RightOutlined } from '@ant-design/icons';
import { getMcpUrl, isMcpEnabled } from '../../../core/config/runtimeConfig';

/**
 * Compact home callout that MCP is available for AI assistants.
 */
const McpAvailabilityTeaser: React.FC = () => {
  if (!isMcpEnabled()) {
    return null;
  }

  const mcpUrl = getMcpUrl();

  return (
    <section
      className="public-panel mt-4"
      aria-labelledby="mcp-availability-heading"
    >
      <div className="public-panel-body flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <p className="public-eyebrow mb-1">For AI assistants</p>
          <h2
            id="mcp-availability-heading"
            className="jo-heading m-0 flex items-center gap-2 text-lg font-black"
          >
            <ApiOutlined className="jo-accent-text" aria-hidden />
            MCP server available
          </h2>
          <p className="jo-body-subtle mb-0 mt-2 text-sm leading-6">
            Connect Cursor, Codex, or any MCP host to search published jobs —
            read-only, no API key.
            {mcpUrl ? (
              <>
                {' '}
                Endpoint:{' '}
                <code className="break-all text-[var(--jo-text)]">
                  {mcpUrl}
                </code>
              </>
            ) : null}
          </p>
        </div>
        <Link
          to="/developers"
          className="public-button-primary inline-flex shrink-0 items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold no-underline"
        >
          Connect with MCP
          <RightOutlined />
        </Link>
      </div>
    </section>
  );
};

export default McpAvailabilityTeaser;
